<template>
  <div>
    <el-select
      v-model="group"
      value-key="name"
      filterable
      clearable
      allow-create
      default-first-option
      placeholder="Выберите или создайте группу"
      @change="v => handleGroupChange(balance._id, v)"
      :loading="groupsLoading"
    >
      <el-option
        v-for="item in balanceAccountGroups.docs"
        :key="item._id"
        :label="item.name"
        :value="item.name"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "balanceAccountGroupChanger",
  props: {
    balance: Object
  },
  data: () => ({}),
  computed: {
    ...mapState("balanceAccounts", ["balanceAccountGroups", "groupsLoading"]),
    group: {
      get() {
        return this.balance.group && this.balance.group.name;
      },
      set(val) {
        return { name: val };
      }
    }
  },
  methods: {
    ...mapActions("balanceAccounts", [
      "editBalanceAccountGroup",
      "getBalanceAccounts",
      "getBalanceAccountGroups"
    ]),
    async handleGroupChange(id, val) {
      try {
        const name = val.name || val;
        await this.editBalanceAccountGroup({ id, group: name });
        await this.getBalanceAccounts();
        await this.getBalanceAccountGroups();
      } catch (error) {
        this.handleResponseError(error);
        return error.response;
      }
    }
  },
  mounted() {
    this.group = { ...this.balance.group };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/groupChanger.vue